export default __webpack_public_path__ + "static/media/photo--lg--chris-1.dbd1fc05.jpg";